// Lightweight Web Audio synth for a system acknowledgement sound.
// Placeholder-quality but tuned to feel organic. Woof for dogs, meow for cats.

let ctx;
const getCtx = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

const noiseBurst = (ac, dest, dur, gain) => {
  const buf = ac.createBuffer(1, Math.floor(ac.sampleRate * dur), ac.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 2);
  const src = ac.createBufferSource();
  src.buffer = buf;
  const g = ac.createGain();
  g.gain.value = gain;
  src.connect(g).connect(dest);
  const t = ac.currentTime;
  src.start(t);
  src.stop(t + dur);
};

export function playWoof() {
  const ac = getCtx();
  if (!ac) return;
  const t = ac.currentTime;
  const master = ac.createGain();
  master.connect(ac.destination);
  master.gain.setValueAtTime(0.0001, t);
  master.gain.exponentialRampToValueAtTime(0.9, t + 0.02);
  master.gain.exponentialRampToValueAtTime(0.28, t + 0.12);
  master.gain.exponentialRampToValueAtTime(0.0001, t + 0.34);

  const bp = ac.createBiquadFilter();
  bp.type = 'bandpass';
  bp.Q.value = 3.5;
  bp.frequency.setValueAtTime(1100, t);
  bp.frequency.exponentialRampToValueAtTime(480, t + 0.26);
  bp.connect(master);

  const lp = ac.createBiquadFilter();
  lp.type = 'lowpass';
  lp.frequency.value = 2200;
  lp.connect(bp);

  [0, -7].forEach((det) => {
    const o = ac.createOscillator();
    o.type = 'sawtooth';
    o.detune.value = det * 3;
    o.frequency.setValueAtTime(300, t);
    o.frequency.exponentialRampToValueAtTime(150, t + 0.18);
    o.connect(lp);
    o.start(t);
    o.stop(t + 0.35);
  });

  noiseBurst(ac, lp, 0.08, 0.22); // breathy "w" onset
}

export function playMeow() {
  const ac = getCtx();
  if (!ac) return;
  const t = ac.currentTime;
  const dur = 0.62;
  const master = ac.createGain();
  master.connect(ac.destination);
  master.gain.setValueAtTime(0.0001, t);
  master.gain.exponentialRampToValueAtTime(0.7, t + 0.08);
  master.gain.setValueAtTime(0.68, t + 0.34);
  master.gain.exponentialRampToValueAtTime(0.0001, t + dur);

  const bp = ac.createBiquadFilter();
  bp.type = 'bandpass';
  bp.Q.value = 6;
  bp.frequency.setValueAtTime(1550, t);        // "eee"
  bp.frequency.linearRampToValueAtTime(1900, t + 0.2);
  bp.frequency.exponentialRampToValueAtTime(760, t + dur); // "ow"
  bp.connect(master);

  const lfo = ac.createOscillator();
  lfo.frequency.value = 13;
  const lg = ac.createGain();
  lg.gain.value = 14;
  lfo.connect(lg);
  lfo.start(t);
  lfo.stop(t + dur);

  [0, -8].forEach((det) => {
    const o = ac.createOscillator();
    o.type = 'sawtooth';
    o.detune.value = det;
    o.frequency.setValueAtTime(470, t);
    o.frequency.linearRampToValueAtTime(680, t + 0.18);
    o.frequency.exponentialRampToValueAtTime(420, t + dur);
    lg.connect(o.frequency);
    o.connect(bp);
    o.start(t);
    o.stop(t + dur);
  });
}

export function playAck(species) {
  if ((species || '').toLowerCase() === 'cat') playMeow();
  else playWoof();
}
